/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_CtaInputs */

const en_visa_eb4_cta = /** @type {(inputs: Visa_Eb4_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your EB-4 eligibility`)
};

const pt_visa_eb4_cta = /** @type {(inputs: Visa_Eb4_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique sua elegibilidade EB-4`)
};

const es_visa_eb4_cta = /** @type {(inputs: Visa_Eb4_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique su elegibilidad EB-4`)
};

/**
* | output |
* | --- |
* | "Check your EB-4 eligibility" |
*
* @param {Visa_Eb4_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_cta = /** @type {((inputs?: Visa_Eb4_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_cta(inputs)
	if (locale === "es") return es_visa_eb4_cta(inputs)
	return en_visa_eb4_cta(inputs)
});